import { Content } from "./ContentBase";

export class RawHtml {
  html:string;
  constructor(html:string) {
    this.html=html;
  }  
}

export function CreateContentRaw(v:RawHtml,setContent:(newContent:Node)=>void):Content {
  let t2=document.createElement("template");
  t2.innerHTML=v.html;
  setContent(t2.content);
  return {
    Update:(nv:RawHtml)=>{},
    Unload:()=>{},
    MatchForUpdate:(nv:RawHtml)=> nv.html===v.html
  }
}